type DFormat = 'short' | 'long';
type DString = string | object;

const dateTimeFormat = (dateString: DString, format: DFormat) => {
  let str;

  switch (typeof dateString) {
    case 'object':
      str = dateString;
      break;
    case 'string':
      if (dateString.length) {
        // Para strings no formato YYYY-MM-DD, criar Date localmente para evitar problemas de timezone
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
          const [year, month, day] = dateString.split('-').map(Number);
          str = new Date(year, month - 1, day);
        } else {
          str = Date.parse(dateString);
        }
      } else {
        str = new Date();
      }
      break;
  }

  try {
    return Intl.DateTimeFormat('pt-br', { dateStyle: format }).format(str);
  } catch {
    return '';
  }
};

const dateShort = (dateString: DString) => dateTimeFormat(dateString, 'short');
const dateLong = (dateString: DString) => dateTimeFormat(dateString, 'long');

export { dateShort, dateLong };
